var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { width: "100%", display: "flex" } }, [
    _c(
      "div",
      {
        staticClass: "header-n",
        class: _vm.inverse ? "inverse " + _vm.customClass : _vm.customClass
      },
      [
        _c("div", { staticClass: "header-desktop" }, [
          !_vm.inverse
            ? _c("img", {
                staticClass: "logo",
                attrs: { src: require("@/assets/logo-white.png"), alt: "" },
                on: { click: _vm.toHome }
              })
            : _c("img", {
                staticClass: "logo",
                attrs: { src: require("@/assets/logo-blue.svg"), alt: "" },
                on: { click: _vm.toHome }
              }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "hd-nav-container" },
            [
              _c("ul", { staticClass: "hd-nav-list" }, [
                _vm.isDashboard
                  ? _c("li", [
                      _c(
                        "a",
                        {
                          staticClass: "fw-bold",
                          attrs: { href: "/#/", "aria-label": "Dashboard" }
                        },
                        [_vm._v("Dashboard")]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      class: _vm.activeMenu === "about-us" ? "fw-bold" : "",
                      attrs: {
                        "aria-label": "About Us",
                        href: _vm.mv_url + "/about-us/"
                      }
                    },
                    [_vm._v("\n              About Us\n            ")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      class: _vm.activeMenu === "musicians" ? "fw-bold" : "",
                      attrs: { "aria-label": "For Musicians" },
                      on: { click: _vm.toMusicians }
                    },
                    [_vm._v("\n              For Musicians\n            ")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "/#/donation-page",
                        "aria-label": "Missions Project"
                      }
                    },
                    [_vm._v("Missions Project\n            ")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: { href: _vm.playerUrl, "aria-label": "Web Player" }
                    },
                    [_vm._v("Web Player")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    { attrs: { href: "/#/premium", "aria-label": "Premium" } },
                    [_vm._v("Premium")]
                  )
                ])
              ]),
              _vm._v(" "),
              !_vm.isDashboard
                ? _c("div", { staticClass: "hd-nav-action" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn-n primary",
                        attrs: { href: "/#/register", "aria-label": "Sign Up" }
                      },
                      [_vm._v("\n            Sign Up\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn-n",
                        class: _vm.inverse ? "outline-primary" : "outline",
                        attrs: { href: "/#/login", "aria-label": "Log In" }
                      },
                      [_vm._v("\n            Log In\n          ")]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isDashboard && _vm.userProfile
                ? _c(
                    "b-dropdown",
                    {
                      attrs: {
                        variant: "link",
                        "toggle-class": "text-decoration-none d-flex",
                        "menu-class": "bg-menu-dropdown",
                        "no-caret": ""
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "button-content",
                            fn: function() {
                              return [
                                _c("img", {
                                  staticClass: "my-auto rounded-circle mr-2",
                                  attrs: {
                                    src: !!_vm.getUser.data.avatar
                                      ? _vm.getUser.data.avatar
                                      : _vm.defaultLogo,
                                    width: "36",
                                    height: "36"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-white my-auto mr-2 d-none d-md-block"
                                  },
                                  [_vm._v(_vm._s(_vm.getUser.data.name))]
                                ),
                                _vm._v(" "),
                                _c("font-awesome-icon", {
                                  staticClass: "text-white my-auto",
                                  attrs: { icon: ["fas", "chevron-down"] }
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        403662401
                      )
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          staticClass: "d-block d-sm-none text-white",
                          attrs: { to: "/home", "link-class": "text-white" }
                        },
                        [_vm._v("Dashboard")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          staticClass: "d-block d-sm-none text-white",
                          attrs: {
                            href: _vm.mv_url + "/about-us/",
                            "link-class": "text-white"
                          }
                        },
                        [_vm._v("About us")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          staticClass: "d-block d-sm-none text-white",
                          attrs: {
                            href: _vm.mv_url + "/musicians/",
                            "link-class": "text-white"
                          }
                        },
                        [_vm._v("Musicians")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          staticClass: "d-block d-sm-none text-white",
                          attrs: {
                            href: _vm.mv_url + "/blog/",
                            "link-class": "text-white"
                          }
                        },
                        [_vm._v("Blog")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          staticClass: "d-block d-sm-none text-white",
                          attrs: {
                            to: "donation-lists",
                            "link-class": "text-white"
                          }
                        },
                        [_vm._v("Mission Projects")]
                      ),
                      _vm._v(" "),
                      _vm.isMonthlySubscriber
                        ? _c(
                            "b-dropdown-item",
                            {
                              staticClass: "text-white",
                              attrs: { "link-class": "text-white" },
                              on: { click: _vm.manageMembership }
                            },
                            [_vm._v("Manage Membership")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          staticClass: "text-white",
                          attrs: { "link-class": "text-white" },
                          on: { click: _vm.logout }
                        },
                        [_vm._v("Logout")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "header-mobile" }, [
          _c("img", {
            staticClass: "logo",
            attrs: {
              src: require("@/assets/logo-white.png"),
              alt: "MusicVerse logo"
            },
            on: { click: _vm.toHome }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "hm-hamburger",
              on: { click: _vm.toggleMenuMobile }
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/hamburger.svg"),
                  alt: "hamburger icon"
                }
              })
            ]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _vm.openMenuMobile
      ? _c("div", { staticClass: "header-menu-mobile" }, [
          _c("div", { staticClass: "hmm-container" }, [
            _c("div", { staticClass: "hmm-header" }, [
              _c("img", {
                attrs: { src: require("@/assets/logo-blue.svg"), alt: "logo" }
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "close",
                  attrs: { href: "javascript:void(0)", "aria-label": "close" },
                  on: { click: _vm.toggleMenuMobile }
                },
                [_vm._v("\n          ×\n        ")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "hmm-nav" }, [
              _vm.isDashboard
                ? _c(
                    "div",
                    {
                      staticClass: "hmm-nav-item",
                      on: { click: _vm.toDashboard }
                    },
                    [_vm._v("Dashboard")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "hmm-nav-item", on: { click: _vm.toAbout } },
                [_vm._v("About Us")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "hmm-nav-item", on: { click: _vm.toMusicians } },
                [_vm._v("For Musicians")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "hmm-nav-item", on: { click: _vm.toMissions } },
                [_vm._v("Missions")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "hmm-nav-item", on: { click: _vm.toPlayer } },
                [_vm._v("Web Player")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "hmm-nav-item", on: { click: _vm.toPremium } },
                [_vm._v("Premium")]
              ),
              _vm._v(" "),
              _vm.isMonthlySubscriber && _vm.isDashboard
                ? _c(
                    "div",
                    {
                      staticClass: "hmm-nav-item",
                      on: { click: _vm.manageMembership }
                    },
                    [_vm._v("Manage Membership")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isDashboard
                ? _c(
                    "div",
                    { staticClass: "hmm-nav-item", on: { click: _vm.logout } },
                    [_vm._v("Logout")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isDashboard
                ? _c("div", { staticClass: "hmm-nav-item action" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn-n primary",
                        attrs: {
                          href: _vm.accountUrl + "/#/register",
                          "aria-label": "Sign Up"
                        }
                      },
                      [_vm._v("\n            Sign Up\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn-n outline-primary",
                        attrs: {
                          href: _vm.accountUrl + "/#/login",
                          "aria-label": "Log In"
                        }
                      },
                      [_vm._v("\n            Log In\n          ")]
                    )
                  ])
                : _vm._e()
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ebe688b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebe688b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderLandingNew.vue
// module id = null
// module chunks = 